<template>
  <v-container>
    <v-breadcrumbs large class="pa-0" :items="breadcrumbsItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-tabs v-model="tab">
      <v-tab key="home">Hlavné údaje</v-tab>
      <v-tab key="body" v-if="model.Body !== null && model.Body.length > 0"
        >Body</v-tab
      >
      <v-tab key="maph" v-if="model.Body !== null && model.Body.length > 0"
        >Mapa Heatmap</v-tab
      >
      <v-tab key="mapc" v-if="model.Body !== null && model.Body.length > 0"
        >Mapa Kruhy</v-tab
      >

      <v-tab-item key="home">
        <v-container class="mt-2 elevation-3">
          <v-row dense>
            <v-col md="2" class="font-weight-black">ID:</v-col>
            <v-col>{{ model.ID }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Názov súboru:</v-col>
            <v-col>{{ model.Filename }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Misia:</v-col>
            <v-col>{{ model.Misia }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Poznámka:</v-col>
            <v-col>{{ model.Poznamka }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn @click="edit()" class="mr-1">Editovať</v-btn>
            </v-col>
          </v-row>
          <v-row dense v-if="model.Image !== null && model.Image !== undefined">
            <v-col cols="12">
              <v-img :src="'data:image/jpeg;base64,' + model.Image" />
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item
        key="body"
        v-if="model.Body !== null && model.Body.length > 0"
      >
        <v-data-table
          :headers="bodyheaders"
          :items="model.Body"
          :items-per-page="10"
          sort-by="ID"
          class="elevation-1 clickableTable"
        ></v-data-table>
      </v-tab-item>
      <v-tab-item
        key="maph"
        v-if="model.Body !== null && model.Body.length > 0"
      >
        <v-container class="mt-2 elevation-3">
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 600px; width: 100%;"
            ref="maph"
            @ready="setMapHView"
          >
            <l-control-scale
              position="topright"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-control position="bottomright">
              <v-img :src="require('../assets/nautical.svg')"></v-img>
            </l-control>
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
          </l-map>
        </v-container>
      </v-tab-item>

      <v-tab-item
        key="mapc"
        v-if="model.Body !== null && model.Body.length > 0"
      >
        <v-container class="mt-2 elevation-3">
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 600px; width: 100%;"
            ref="mapc"
            @ready="setMapCView"
          >
            <l-control-scale
              position="topright"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-control position="bottomright">
              <v-img :src="require('../assets/nautical.svg')"></v-img>
            </l-control>
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />

            <template v-for="(bod, i) in heatmapData">
              <l-circle-marker
                :key="`marker-${i}`"
                :lat-lng="[bod.lat, bod.lng]"
                :radius="5"
                :fill="true"
                :fillOpacity="0.9"
                :fillColor="mycolors[bod.percentile]"
                :color="mycolors[bod.percentile]"
              >
                <l-tooltip>{{ bod.count }}</l-tooltip>
              </l-circle-marker>
            </template>
          </l-map>
          <v-row no-gutters class="pt-5">
            <v-col cols="1"></v-col>
            <v-col cols="1" v-for="color in mycolors" :key="'id' + color">
              <span
                :style="
                  `background-color: ${color}; width: 100%; height: 25px; display: block`
                "
              ></span>
            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="2" class="text-center" style="font-size: 9pt">
              {{ this.heatMin }}
            </v-col>
            <v-col cols="8"></v-col>
            <v-col cols="2" class="text-center" style="font-size: 9pt">
              {{ this.heatMax }}
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <insar-detail
      ref="dialogInsar"
      @change="readInsar(id)"
      @delete="showLokalita()"
    ></insar-detail>
  </v-container>
</template>

<script>
import InsarDetail from "../components/InsarDetail.vue"
import {
  LMap,
  LTileLayer,
  LCircleMarker,
  LTooltip,
  LControl,
  LControlLayers,
  LControlScale
} from "vue2-leaflet"
import HeatmapOverlay from "leaflet-heatmap"
import * as Miscella from "../plugins/miscella.js"

export default {
  components: {
    InsarDetail,
    LMap,
    LTileLayer,
    LCircleMarker,
    LTooltip,
    LControl,
    LControlLayers,
    LControlScale
  },

  props: ["id"],

  data: () => ({
    tab: 0,
    model: {
      Body: []
    },
    mycolors: [
      "#FF0000ff",
      "#FF4040ff",
      "#FF8080ff",
      "#FFBFBFff",
      "#FFFFFFff",
      "#CCCFFFff",
      "#99A0FFff",
      "#6670FFff",
      "#3341FFff",
      "#0011FFff"
    ],

    bodyheaders: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      { text: "Bod", align: "left", sortable: true, value: "Bod" },
      { text: "Lat", align: "right", sortable: true, value: "Lat" },
      { text: "Lon", align: "right", sortable: true, value: "Lon" },
      { text: "Height", align: "right", sortable: true, value: "Height" },
      { text: "Northing", align: "right", sortable: true, value: "Northing" },
      { text: "Easting", align: "right", sortable: true, value: "Easting" },
      {
        text: "Elevation",
        align: "right",
        sortable: true,
        value: "Elevation"
      },
      {
        text: "HeightWrtDem",
        align: "right",
        sortable: true,
        value: "HeightWrtDem"
      },
      {
        text: "SigmaHeight",
        align: "right",
        sortable: true,
        value: "SigmaHeight"
      },
      { text: "Vel", align: "right", sortable: true, value: "Vel" },
      { text: "SigmaVel", align: "right", sortable: true, value: "SigmaVel" },
      { text: "Up", align: "right", sortable: true, value: "Up" },
      { text: "Ew", align: "right", sortable: true, value: "Ew" },
      { text: "CumulDisp", align: "right", sortable: true, value: "CumulDisp" },
      { text: "Coher", align: "right", sortable: true, value: "Coher" },
      { text: "Stdev", align: "right", sortable: true, value: "Stdev" },
      { text: "Grid", align: "right", sortable: true, value: "Grid" }
    ],

    mapOptions: {
      zoomSnap: 0.5
    },

    zoom: 8,
    center: [48.6, 19.7],
    url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
    heatmapLayer: null,
    heatmapData: null,
    heatMin: 0,
    heatMax: 0,
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ]
  }),

  computed: {
    breadcrumbsItems: function() {
      let ret = []
      if (Miscella.isSet(this.model) && Miscella.isSet(this.model.LokalitaID)) {
        ret = [
          {
            to: { name: "lokalita", params: { id: this.model.LokalitaID } },
            text: "Lokalita " + this.model.LokalitaName
          },
          { text: "Insar " + this.id }
        ]
      }
      return ret
    }
  },

  methods: {
    edit: function() {
      this.$refs.dialogInsar.show(this.model)
    },
    showLokalita: function() {
      this.$router.push({
        name: "lokalita",
        params: { id: this.model.LokalitaID }
      })
    },
    readInsar: async function(id) {
      try {
        let response = await this.$axios.get("/r/insar/" + id)
        if (response.status === 200) {
          this.model = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readInsarHeapmapData: async function(id) {
      try {
        let response = await this.$axios.get(`/r/insar/${id}/heatmap`)
        if (response.status === 200) {
          this.heatmapData = response.data
          let min = 0
          let max = 0
          for (let i = 0; i < this.heatmapData.length; i++) {
            const el = this.heatmapData[i]
            if (el.count > max) {
              max = el.count
            }
            if (el.count < min) {
              min = el.count
            }
          }
          this.heatMin = min
          this.heatMax = max
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },

    setMapHView: async function() {
      await this.readInsarHeapmapData(this.id)
      var cfg = {
        // radius should be small ONLY if scaleRadius is true (or small radius is intended)
        // if scaleRadius is false it will be the constant radius used in pixels
        radius: 10,
        //maxOpacity: 0.8,
        // scales the radius based on map zoom
        scaleRadius: false,
        // if set to false the heatmap uses the global maximum for colorization
        // if activated: uses the data maximum within the current map boundaries
        //   (there will always be a red spot with useLocalExtremas true)
        useLocalExtrema: true,
        // which field name in your data represents the latitude - default "lat"
        latField: "lat",
        // which field name in your data represents the longitude - default "lng"
        lngField: "lng",
        // which field name in your data represents the data value - default "value"
        valueField: "count"
      }
      this.heatmapLayer = new HeatmapOverlay(cfg)
      this.$refs.maph.mapObject.addLayer(this.heatmapLayer)
      console.log("map view set")
      this.heatmapLayer.setData({ data: this.heatmapData })
    },

    setMapCView: async function() {
      await this.readInsarHeapmapData(this.id)
      this.$nextTick(() => {
        if (this.heatmapData.length > 0) {
          this.$refs.mapc.mapObject.setView(
            [this.heatmapData[0].lat, this.heatmapData[0].lng],
            12
          )
        }
      })
    }
  },

  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    await this.readInsar(this.id)
  }
}
</script>
